import React, { useState, useRef } from "react";

const ImageMagnifier = ({
  src,
  alt = "product",
  width = "100%",
  height = "auto",
  zoom = 3,
  magnifierSize = 220, // size of the zoomed box
  className = "",
}) => {
  const [position, setPosition] = useState({ x: 0, y: 0, show: false });
  const imgRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!imgRef.current) return;

    const img = imgRef.current;
    const { left, top, width: w, height: h } = img.getBoundingClientRect();

    const x = ((e.clientX - left) / w) * 100;
    const y = ((e.clientY - top) / h) * 100;

    setPosition({ x, y, show: true });
  };

  const handleMouseLeave = () => {
    setPosition((prev) => ({ ...prev, show: false }));
  };

  return (
    <div className={`relative inline-block ${className}`}>
      {/* Original Image */}
      <div
        className="relative overflow-hidden cursor-crosshair"
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        style={{ width, height }}
      >
        <img
          ref={imgRef}
          src={src || "/imageNotFound.png"}
          alt={alt}
          className="w-full h-full object-cover rounded-md transition-transform hover:scale-105"
          style={{ display: "block" }}
          loading="lazy"
        />
      </div>

      {/* Zoomed Magnifier (appears on the right) */}
      {position.show && (
        <div
          className="absolute left-full top-1/2 -translate-y-1/2 ml-6 pointer-events-none z-10 hidden lg:block"
          style={{
            width: magnifierSize,
            height: magnifierSize,
            backgroundImage: `url(${src || "/imageNotFound.png"})`,
            backgroundSize: `${zoom * 100}%`,
            backgroundPosition: `${position.x}% ${position.y}%`,
            backgroundRepeat: "no-repeat",
            border: "3px solid #fff",
            borderRadius: "12px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
          }}
        />
      )}
    </div>
  );
};

export default ImageMagnifier;